// extracted by mini-css-extract-plugin
export var cartIcon = "_lx-0";
export var cartIconContainer = "_lx-1";